import React, { useEffect } from "react";
import { CloseIcon } from "../Icons";
import { BRAND_THEME } from "../ui/brandTheme";

/**
 * Shared modal shell — Patient brand header/close by default.
 * Used by Documents history and other modules.
 */
const Modal = ({ isOpen, onClose, title, children, size = "md" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const maxWidthClasses = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className={`bg-white rounded-xl border border-indigo-200 shadow-xl w-full ${maxWidthClasses[size]} transform transition-all flex flex-col max-h-[90vh] overflow-hidden`}
        role="dialog"
        aria-modal="true"
      >
        <div
          className={`flex items-center justify-between gap-3 px-4 py-3 border-b shrink-0 ${BRAND_THEME.modalHead}`}
        >
          <h3
            className={`text-sm font-semibold uppercase tracking-wide min-w-0 truncate ${BRAND_THEME.modalTitle}`}
          >
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-7 w-7 items-center justify-center rounded-md text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 transition-colors shrink-0"
            title="Close"
            aria-label="Close"
          >
            <CloseIcon size={14} />
          </button>
        </div>

        <div className="p-3 sm:p-4 overflow-x-auto overflow-y-auto bg-slate-50/40 flex-1 min-w-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
